// Web SVG primitives for the Relic Vault icons.
//
// Mirrors the components/Icons.web.js approach: render real DOM <svg> on web
// instead of react-native-svg, so the icons are drawn identically to the
// designer's handoff. Same component names as svg.js so icons are written once.
import React from 'react';

export const Svg = ({ children, style, ...props }) => (
  <svg style={{ display: 'block', ...(style || {}) }} {...props}>
    {children}
  </svg>
);
export const Path = props => <path {...props} />;
export const Circle = props => <circle {...props} />;
export const Rect = props => <rect {...props} />;
